import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { conversationListPageURL } from 'dashboard/helper/URLHelper';

// SuperTVGo: deselecionar a conversa aberta e voltar pra lista — sem isso o
// único jeito era sair da tela e entrar de novo. Não confundir com
// "Resolver": aqui só fecha a visualização, o status da conversa não muda.
export function useCloseConversationView() {
  const route = useRoute();
  const router = useRouter();
  const store = useStore();

  const accountId = computed(() => store.getters.getCurrentAccountId);

  const closeConversationUrl = computed(() => {
    const {
      params: { inbox_id: inboxId, label, teamId, id: customViewId },
      name,
    } = route;

    const conversationTypeMap = {
      conversation_through_mentions: 'mention',
      conversation_through_participating: 'participating',
      conversation_through_unattended: 'unattended',
    };

    return conversationListPageURL({
      accountId: accountId.value,
      inboxId,
      label,
      teamId,
      conversationType: conversationTypeMap[name],
      customViewId,
    });
  });

  const closeConversationView = () => {
    router.push(closeConversationUrl.value);
  };

  return { closeConversationUrl, closeConversationView };
}
